import { ISelectable } from './../../global/servants/selection_list_servant';
import { IIndexable, key } from 'core-ts-types';

export class StudentTerm implements IIndexable, ISelectable {
  id: key;
  nk: string;
  name: string;
  term_start_date: string;
  term_end_date: string;
  display_end_date: string;
  isSelected = false;

  constructor(item: any) {
    _.merge(this, item);
  }

  static build(item: any) {
    return new StudentTerm(item);
  }
}

angular.module('capability-ng-user-app').factory('ngStudentTermBuilder', (): typeof StudentTerm => {
  return StudentTerm;
});



// WEBPACK FOOTER //
// ./app/lib/user_app/builders/student_term_builder.ts